import React from 'react';
import { createPortal } from 'react-dom';
import { DynamicTableViewer } from './index';

export function RecordSelectorModal({ targetTable, token, onSelect, onCancel }) {
    return createPortal(
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/80 p-4 sm:p-8">
            <div className="bg-slate-900 border border-slate-700 shadow-2xl rounded-xl w-full max-w-7xl h-[85vh] flex flex-col overflow-hidden relative">
                
                {/* Header */}
                <div className="px-6 py-4 border-b border-slate-800 bg-slate-800/50 flex justify-between items-center shrink-0">
                    <div>
                        <h2 className="text-xl font-bold text-slate-100 flex items-center gap-2">
                            <span className="material-symbols-outlined text-teal-400">search</span>
                            Select Record: <span className="text-teal-400">{targetTable}</span>
                        </h2>
                        <p className="text-sm text-slate-400 mt-1">Search and click a row to link it.</p>
                    </div>
                    <button 
                        onClick={onCancel}
                        className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
                        title="Cancel"
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                {/* Body (Dynamic Table) */}
                <div className="flex-1 overflow-hidden relative bg-slate-950">
                    <DynamicTableViewer 
                        targetTable={targetTable}
                        token={token}
                        selectionMode={true}
                        onSelectRecord={onSelect}
                        viewKey={`RecordSelector_${targetTable}`}
                    />
                </div>
            </div>
        </div>,
        document.body
    );
}
